import { useEffect } from 'react';
import { v4 } from 'uuid';

type LoadScriptProps = {
  onLoad: () => void;
  onError?: () => void;
  url: string;
};

export const LoadScript = ({ onError, onLoad, url }: LoadScriptProps) => {
  useEffect(() => {
    const scriptId = v4();
    const existingScript = document.getElementById(scriptId);
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.src = url;
      script.async = true;

      script.onload = () => onLoad();

      script.onerror = () => onError?.();
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    return () => {
      const jsScript = document.getElementById(scriptId);
      if (jsScript) {
        document.getElementsByTagName('head')[0].removeChild(jsScript);
      }
    };
  }, [onError, onLoad, url]);

  return null;
};
